import { deleteApi, getApi, postApi, putApi } from "./general.service";

export const getCategory = async (data) => {
  const category = getApi("/admin/category", { params: { ...data, light: true } });
  return category;
};

export const getCategoryById = async (id) => {
  return getApi(`/admin/category/${id}`);
};

export const createCategory = async (data) => {
  const category = postApi("/admin/category", data);
  return category;
};

export const updateCategory = async (data) => {
  const category = putApi("/admin/category", data);
  return category;
};

export const deleteCategory = async (id) => {
  return deleteApi(`/admin/category?_id=${id}`);
};

/** Reorder categories by calling PUT for each with new id (order index). */
export const reorderCategories = async (categoryIds) => {
  for (let i = 0; i < categoryIds.length; i++) {
    const result = await updateCategory({ _id: categoryIds[i], id: i });
    if (result?.response) throw result;
  }
  return { data: { ok: true } };
};
